import { AccountTypes } from '@app/entities/enums/payslips/account.enum';

export class DirectDebitAccount {
  bankName?: string;
  type?: AccountTypes;
  numberAccount?: string;
}
